import { render } from "./ImageSlides.vue?vue&type=template&id=79dd244d&scoped=true&ts=true"
import script from "./ImageSlides.vue?vue&type=script&lang=ts"
export * from "./ImageSlides.vue?vue&type=script&lang=ts"

import "./ImageSlides.vue?vue&type=style&index=0&id=79dd244d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dd244d"]])

export default __exports__